// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"yaa-z","narrowOptionButtons":"zaa-z","noOptions":"Aaa-z"};